import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../components/Logo White.png";

function Footer() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth <= 768;
  const isTablet = windowWidth > 768 && windowWidth <= 1024;

  const styles = {
    footerSystem: {
      background: "#151413", // Exact rich dark background match from image
      padding: isMobile ? "50px 20px 30px" : "60px 40px 30px",
      fontFamily: "'Inter', 'Plus Jakarta Sans', sans-serif",
      color: "#ffffff",
      width: "100%",
      boxSizing: "border-box",
      overflowX: "hidden",
    },

    container: {
      maxWidth: "1320px",
      margin: "0 auto",
      width: "100%",
    },

    flexLayout: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      flexWrap: "wrap",
      gap: isMobile ? "35px" : "20px",
      justifyContent: "space-between",
      alignItems: isMobile ? "center" : "flex-start",
      marginBottom: "50px",
      textAlign: isMobile ? "center" : "left",
    },

    brandCol: {
      display: "flex",
      flexDirection: "column",
      gap: "28px", // Clean precise gap between logo, icons, and mail id
      alignItems: isMobile ? "center" : "flex-start",
      flex: isMobile ? "1 1 100%" : isTablet ? "1 1 220px" : "1 1 260px",
    },

    brandLogo: {
      height: isMobile ? "90px" : isTablet ? "110px" : "160px", // Match layout scale ratio precisely
      width: "auto",
      objectFit: "contain",
    },

    socialIcons: {
      display: "flex",
      gap: "14px",
      justifyContent: isMobile ? "center" : "flex-start",
    },

    socialLink: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fill: "#a3a3a3",
      transition: "all 0.2s ease-in-out",
    },

    emailText: {
      fontSize: "14px",
      color: "#a3a3a3",
      textDecoration: "none",
      fontWeight: "400",
      letterSpacing: "0.3px",
      transition: "color 0.2s ease",
    },

    // Column 2 Link Layout Block
    navCol: {
      display: "flex",
      flexDirection: "column",
      gap: "18px",
      paddingTop: isMobile ? "0px" : "10px",
      alignItems: isMobile ? "center" : "flex-start",
      flex: isMobile ? "1 1 auto" : "0 1 100px",
    },

    linksCol: {
      display: "flex",
      flexDirection: "column",
      gap: "7px", // Tight elegant line spacing as seen in image
      alignItems: isMobile ? "center" : "flex-start",
      flex: isMobile ? "1 1 100%" : isTablet ? "1 1 200px" : "1 1 230px",
    },

    subGroupGap: {
      display: "flex",
      flexDirection: "column",
      gap: "7px",
      width: "100%",
      alignItems: isMobile ? "center" : "flex-start",
      marginTop: "20px",
    },

    columnHeader: {
      fontSize: "13.5px",
      fontWeight: "600",
      color: "#ffffff",
      paddingBottom: "3px",
      borderBottom: "1px solid #ffffff", // Clean accent underline from image layout
      display: "inline-block",
      marginBottom: "8px",
      whiteSpace: "nowrap",
    },

    baseLink: {
      textDecoration: "none",
      fontSize: "12.5px",
      fontWeight: "400",
      color: "#b3b3b3",
      transition: "color 0.2s ease",
      lineHeight: "1.4",
      wordBreak: "break-word",
    },

    bottomCopyrightLayer: {
      borderTop: "1px solid #232221",
      paddingTop: "20px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontSize: "12.5px",
      color: "#8c8c8c",
      textAlign: "center",
      flexWrap: "wrap",
    },

    copyrightLinks: {
      color: "#8c8c8c",
      textDecoration: "none",
      marginLeft: "6px",
      marginRight: "6px",
      transition: "color 0.2s ease",
    },
  };

  return (
    <footer style={styles.footerSystem}>
      <div style={styles.container}>
        <div style={styles.flexLayout}>

          {/* Column 1: Brand Directory Section */}
          <div style={styles.brandCol}>
            <img src={logo} alt="Zeropix Creative" style={styles.brandLogo} />
              <div style={styles.navCol}>
            <Link to="/about" style={{...styles.baseLink, color: "#ffffff", fontWeight: "500"}} onMouseEnter={(e) => e.currentTarget.style.color = "#a3a3a3"} onMouseLeave={(e) => e.currentTarget.style.color = "#ffffff"}>About</Link>
            <Link to="/services" style={{...styles.baseLink, color: "#ffffff", fontWeight: "500"}} onMouseEnter={(e) => e.currentTarget.style.color = "#a3a3a3"} onMouseLeave={(e) => e.currentTarget.style.color = "#ffffff"}>Services</Link>
            <Link to="/portfolio" style={{...styles.baseLink, color: "#ffffff", fontWeight: "500"}} onMouseEnter={(e) => e.currentTarget.style.color = "#a3a3a3"} onMouseLeave={(e) => e.currentTarget.style.color = "#ffffff"}>Portfolio</Link>
            <Link to="/contact" style={{...styles.baseLink, color: "#ffffff", fontWeight: "500"}} onMouseEnter={(e) => e.currentTarget.style.color = "#a3a3a3"} onMouseLeave={(e) => e.currentTarget.style.color = "#ffffff"}>Contact</Link>
          </div>
            <div style={styles.socialIcons}>
              {/* Facebook */}
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noreferrer"
                style={styles.socialLink}
                onMouseEnter={(e) => e.currentTarget.style.fill = "#fff"}
                onMouseLeave={(e) => e.currentTarget.style.fill = "#a3a3a3"}
              >
                <svg width="20" height="20" viewBox="0 0 24 24">
                  <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
                </svg>
              </a>

              {/* WhatsApp */}
              <a
                href="https://wa.me/9487177305"
                target="_blank"
                rel="noreferrer"
                style={styles.socialLink}
                onMouseEnter={(e) => e.currentTarget.style.fill = "#25D366"}
                onMouseLeave={(e) => e.currentTarget.style.fill = "#a3a3a3"}
              >
                <svg width="20" height="20" viewBox="0 0 24 24">
                  <path d="M20.52 3.48A11.91 11.91 0 0012.05 0C5.43 0 .05 5.38.05 12c0 2.11.55 4.17 1.6 5.99L0 24l6.17-1.61A11.94 11.94 0 0012.05 24c6.62 0 12-5.38 12-12 0-3.19-1.24-6.19-3.53-8.52zM12.05 21.8c-1.87 0-3.7-.5-5.3-1.44l-.38-.22-3.66.96.98-3.57-.24-.37a9.77 9.77 0 01-1.5-5.16c0-5.4 4.4-9.8 9.8-9.8 2.62 0 5.09 1.02 6.94 2.87a9.75 9.75 0 012.86 6.93c0 5.4-4.4 9.8-9.8 9.8zm5.37-7.35c-.29-.15-1.72-.85-1.98-.95-.27-.1-.46-.15-.66.15-.2.3-.76.95-.93 1.15-.17.2-.34.22-.63.07-1.7-.85-2.82-1.52-3.95-3.43-.3-.5.3-.47.86-1.57.1-.2.05-.37-.02-.52-.07-.15-.66-1.6-.9-2.2-.24-.58-.48-.5-.66-.5-.17 0-.37-.02-.57-.02-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.5 0 1.48 1.06 2.91 1.21 3.11.15.2 2.1 3.2 5.1 4.48.7.3 1.25.48 1.67.61.7.22 1.34.19 1.85.12.57-.08 1.72-.7 1.97-1.37.25-.68.25-1.26.17-1.37-.08-.11-.27-.17-.56-.32z" />
                </svg>
              </a>

              {/* Instagram */}
              <a
                href="https://www.instagram.com/zero_pix_creative"
                target="_blank"
                rel="noreferrer"
                style={styles.socialLink}
                onMouseEnter={(e) => e.currentTarget.style.fill = "#fff"}
                onMouseLeave={(e) => e.currentTarget.style.fill = "#a3a3a3"}
              >
                <svg width="20" height="20" viewBox="0 0 24 24">
                  <path d="M7.75 2C4.57 2 2 4.57 2 7.75v8.5C2 19.43 4.57 22 7.75 22h8.5C19.43 22 22 19.43 22 16.25v-8.5C22 4.57 19.43 2 16.25 2h-8.5zm0 2h8.5C18.22 4 20 5.78 20 7.75v8.5c0 1.97-1.78 3.75-3.75 3.75h-8.5C5.78 20 4 18.22 4 16.25v-8.5C4 5.78 5.78 4 7.75 4zm4.25 2.5A5.75 5.75 0 106.25 12 5.75 5.75 0 0012 6.5zm0 2A3.75 3.75 0 118.25 12 3.75 3.75 0 0112 8.5zm4.88-.63a1.12 1.12 0 11-2.25 0 1.12 1.12 0 012.25 0z" />
                </svg>
              </a>
            </div>

            <a 
              href="mailto:design.zeropixcreative@gmail.com" 
              style={styles.emailText}
              onMouseEnter={(e) => e.currentTarget.style.color = "#ffffff"}
              onMouseLeave={(e) => e.currentTarget.style.color = "#a3a3a3"}
            >
              design.zeropixcreative@gmail.com
            </a>
          </div>

          {/* Column 2: Standalone Corporate Actions */}
          {/* <div style={styles.navCol}>
            <Link to="/about" style={{...styles.baseLink, color: "#ffffff", fontWeight: "500"}} onMouseEnter={(e) => e.currentTarget.style.color = "#a3a3a3"} onMouseLeave={(e) => e.currentTarget.style.color = "#ffffff"}>About</Link>
            <Link to="/services" style={{...styles.baseLink, color: "#ffffff", fontWeight: "500"}} onMouseEnter={(e) => e.currentTarget.style.color = "#a3a3a3"} onMouseLeave={(e) => e.currentTarget.style.color = "#ffffff"}>Services</Link>
            <Link to="/portfolio" style={{...styles.baseLink, color: "#ffffff", fontWeight: "500"}} onMouseEnter={(e) => e.currentTarget.style.color = "#a3a3a3"} onMouseLeave={(e) => e.currentTarget.style.color = "#ffffff"}>Portfolio</Link>
            <Link to="/contact" style={{...styles.baseLink, color: "#ffffff", fontWeight: "500"}} onMouseEnter={(e) => e.currentTarget.style.color = "#a3a3a3"} onMouseLeave={(e) => e.currentTarget.style.color = "#ffffff"}>Contact</Link>
          </div> */}

          {/* Column 3: Real Estate & Video Editing */}
          <div style={styles.linksCol}>
            <div><span style={styles.columnHeader}>Real Estate Editing</span></div>
            <Link to="/services/photo-editing" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Photo Editing</Link>
            <Link to="/services/virtual-staging" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Virtual Staging</Link>
            <Link to="/services/hdr-photos" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>HDR Photos</Link>
            <Link to="/services/day-to-dusk" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Day-to-Dusk Conversion (Twilight)</Link>
            <Link to="/services/colour-balancing" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Interior Colour Balancing</Link>
            <Link to="/services/sky-replacement" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Sky Replacement</Link>
            <Link to="/services/perspective-correction" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Perspective Correction</Link>
            <Link to="/services/furniture-cleanup" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Furniture Clean-up</Link>
            <Link to="/services/item-removal" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Amenity Highlights Editing (Item Removal)</Link>

            <div style={styles.subGroupGap}>
              <div><span style={styles.columnHeader}>Video Editing</span></div>
              <Link to="/services/walkthrough-video" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Walkthrough Video Editing</Link>
              <Link to="/services/cinematic-editing" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Cinematic Real Estate Editing</Link>
              <Link to="/services/social-media-editing" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Social Media / Reel Editing</Link>
              <Link to="/services/promo-editing" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Promotional / Advertisement Editing</Link>
              <Link to="/services/map-location-highlight" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Map & Location Highlight Editing</Link>
              <Link to="/services/agent-presentation" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Agent Presentation / Talking Head Editing</Link>
              <Link to="/services/drone-footage-editing" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Drone Footage Editing</Link>
            </div>
          </div>

          {/* Column 4: Photography & Videography Blocks */}
          <div style={styles.linksCol}>
            <div><span style={styles.columnHeader}>Photography</span></div>
            <Link to="/services/architectural-photography" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Architectural Photography</Link>
            <Link to="/services/portrait-photography" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Portrait Photography</Link>
            <Link to="/services/fashion-photography" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Fashion Photography</Link>
            <Link to="/services/food-photography" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Food Photography</Link>
            <Link to="/services/wedding-photography" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Wedding Photography</Link>
            <Link to="/services/product-photography" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Product Photography</Link>
            <Link to="/services/event-photography" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Event Photography</Link>

            <div style={styles.subGroupGap}>
              <div><span style={styles.columnHeader}>Videography</span></div>
              <Link to="/services/real-estate-videography" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Real Estate Videography</Link>
              <Link to="/services/cinematic-videography" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Cinematic / Film Videography</Link>
              <Link to="/services/wedding-videography" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Wedding Videography</Link>
              <Link to="/services/commercial-videography" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Commercial / Advertisement Videography</Link>
              <Link to="/services/social-media-videography" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Social Media Videography</Link>
              <Link to="/services/corporate-videography" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Corporate Videography</Link>
              <Link to="/services/event-videography" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Event Videography</Link>
              <Link to="/services/dronography" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Dronography</Link>
            </div>
          </div>

          {/* Column 5: Design Studio Array */}
          <div style={styles.linksCol}>
            <div><span style={styles.columnHeader}>Graphic Design (Marketing & Advertising)</span></div>
            <Link to="/services/posters" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Posters</Link>
            <Link to="/services/banners" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Banners</Link>
            <Link to="/services/social-ads" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>social media ads</Link>
            <Link to="/services/brochures" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>brochures</Link>
            <Link to="/services/flyers" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>flyers Packaging Design</Link>
            <Link to="/services/product-packaging" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Product packaging</Link>
            <Link to="/services/packaging-boxes" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Boxes, labels, wrappers</Link>

            <div style={styles.subGroupGap}>
              <div><span style={styles.columnHeader}>Motion Graphics Design</span></div>
              <Link to="/services/animated-graphics" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Animated graphics</Link>
              <Link to="/services/animations-gifs" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Videos, animations, GIFs</Link>
              <Link to="/services/commercial-editing" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Commercial / Advertisement Editing</Link>
              <Link to="/services/social-editing" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Social Media Editing</Link>
              <Link to="/services/documentary-editing" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Documentary Editing</Link>
              <Link to="/services/music-video-editing" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Music Video Editing</Link>
              <Link to="/services/corporate-video-editing" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Corporate Video Editing</Link>
              <Link to="/services/vfx-editing" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Motion Graphics & VFX Editing</Link>
              <Link to="/services/tutorial-editing" style={styles.baseLink} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#b3b3b3"}>Educational / Tutorial Editing</Link>
            </div>
          </div>

        </div>

        {/* Bottom Copyright Layer */}
        <div style={styles.bottomCopyrightLayer}>
          <span>
            Copyrights © <b>Zero Pix Creative</b> | 
            <a href="/terms" style={styles.copyrightLinks} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#8c8c8c"}>Terms</a> | 
            <a href="/privacy" style={styles.copyrightLinks} onMouseEnter={(e) => e.currentTarget.style.color = "#fff"} onMouseLeave={(e) => e.currentTarget.style.color = "#8c8c8c"}>Privacy</a>
          </span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;